module.exports = __webpack_public_path__ + "static/box-a921c766a4cab9c6a2e3fdc2fcf76296.png";